export const FETCHING_ACTIVITYLOG = 'FETCHING_ACTIVITYLOG';